import '../styles/contact.scss';
import React from 'react';
import {items } from "../services/data.ts"
import Process from './process.jsx';

const Contact = () => {

  return (
    <section  className="contact-section">
      <Process />
      <div className="hero-text-container">
        <a href={items.whatsapp} target='_blank'>
          <h3 className="hero-title">
            Agende um orçamento
          </h3>
        </a>
      </div>
    </section>
  );
};

export default Contact;